module.exports = "/images/img_guide01.png?0e2d85f6af9ca38cad645aa36250110a";